import type { MailingAddress } from '@/services/types/coverage-types';

export const emptyMailingAddress = (): MailingAddress => ({
  address_line1: '',
  address_line2: '',
  city: '',
  state: '',
  zip_code: '',
  country: 'US',
});

export const formatMailingAddress = (
  mailingAddress?: MailingAddress | null,
): string => {
  if (!mailingAddress) return '';

  const locality = [mailingAddress.city, mailingAddress.state, mailingAddress.zip_code]
    .filter(Boolean)
    .join(', ')
    .replace(/, ([A-Z]{2}), (\d{5}(?:-\d{4})?)$/, ', $1 $2');
  const parts = [mailingAddress.address_line1, mailingAddress.address_line2, locality].filter(
    Boolean,
  );

  return parts.join(', ');
};

export const mailingAddressFromSources = (
  mailingAddress?: MailingAddress | null,
): MailingAddress => {
  if (!mailingAddress) return emptyMailingAddress();

  return {
    address_line1: mailingAddress.address_line1 || '',
    address_line2: mailingAddress.address_line2 || '',
    city: mailingAddress.city || '',
    state: mailingAddress.state || '',
    zip_code: mailingAddress.zip_code || '',
    country: mailingAddress.country || 'US',
  };
};

export const mailingAddressHasAnyValue = (
  mailingAddress?: MailingAddress | null,
): boolean => {
  if (!mailingAddress) return false;
  return Boolean(
    mailingAddress.address_line1?.trim() ||
      mailingAddress.address_line2?.trim() ||
      mailingAddress.city?.trim() ||
      mailingAddress.state?.trim() ||
      mailingAddress.zip_code?.trim(),
  );
};

export const isMailingAddressComplete = (
  mailingAddress?: MailingAddress | null,
): boolean => {
  if (!mailingAddress) return false;
  return Boolean(
    mailingAddress.address_line1?.trim() &&
      mailingAddress.city?.trim() &&
      mailingAddress.state?.trim() &&
      mailingAddress.zip_code?.trim(),
  );
};

export const normalizeMailingAddress = (
  mailingAddress?: MailingAddress | null,
): MailingAddress | null => {
  if (!mailingAddressHasAnyValue(mailingAddress)) return null;
  if (!isMailingAddressComplete(mailingAddress)) return null;

  return {
    address_line1: mailingAddress?.address_line1.trim() || '',
    address_line2: mailingAddress?.address_line2?.trim() || undefined,
    city: mailingAddress?.city.trim() || '',
    state: mailingAddress?.state.trim().toUpperCase() || '',
    zip_code: mailingAddress?.zip_code.trim() || '',
    country: mailingAddress?.country || 'US',
  };
};
